import { slugs } from '@/constants/slugs'
import {
  getSketchFaqs,
  getKingOfKingsFaqs,
  getLastRodeoFaqs,
  getYoungWashingtonFaqs,
  getSeniorFaqs,
  getTruthAndTreasonFaqs,
  getDavidFaqs,
  getIwasFaqs,
} from './projects'
import { GiveawayFaq } from './types'

const FAQ_CONFIGS: Record<string, () => GiveawayFaq[]> = {
  [slugs.sketch]: getSketchFaqs,
  [slugs.kingOfKings]: getKingOfKingsFaqs,
  [slugs.theLastRodeo]: getLastRodeoFaqs,
  [slugs.youngWashington]: getYoungWashingtonFaqs,
  [slugs.senior]: getSeniorFaqs,
  [slugs.truthAndTreason]: getTruthAndTreasonFaqs,
  [slugs.david]: getDavidFaqs,
  [slugs.iWasAStranger]: getIwasFaqs,
}

export const getGiveawayFaqs = (theatricalSlug: string): GiveawayFaq[] => {
  const getFaqs = FAQ_CONFIGS[theatricalSlug]
  return getFaqs ? getFaqs() : []
}

export const hasProjectFaqs = (theatricalSlug: string): boolean => {
  return getGiveawayFaqs(theatricalSlug).length > 0
}

export * from './types'
export * from './shared'
